export default "/_next/static/images/effect-right-2-f9763b1a04c17feea95586659c8f8a50.svg";